import { Grid } from "@material-ui/core";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { ToastMessage } from "../../../components";
import { HighlightForm } from "../../../components/highlight-form";
import { HighlightsStyles } from "./add-highlight.styles";

const ON_SUCCESS = "The highlight was addedd successfully.";
const SUCCESS = "success";
const ON_ERROR = "There was an error, please try again.";
const ERROR = "error";

type Toast = {
  message: string;
  open: boolean;
  status: string;
};

const initialToast = {
  message: "",
  open: false,
  status: "",
};

export const AddHighlight = () => {
  const classes = HighlightsStyles();
  const [toast, setToast] = useState<Toast>(initialToast);
  const queryClient = useQueryClient();

  const onSubmitCallback = async ({ message, status }) => {
    if (status === SUCCESS) {
      await queryClient.invalidateQueries({
        queryKey: ["highlights"],
        refetchPage: (_page, index) => index === 0,
      });
    }
    setToast((prevState) => ({
      ...prevState,
      open: !prevState.open,
      message,
      status,
    }));
  };

  return (
    <Grid container spacing={1} className={classes.root}>
      <HighlightForm
        title="Add a Highlight"
        onHighlightSaveSuccess={() =>
          onSubmitCallback({
            message: ON_SUCCESS,
            status: SUCCESS,
          })
        }
        enabledGetHighlight={false}
        onHighlightSaveError={() =>
          onSubmitCallback({ message: ON_ERROR, status: ERROR })
        }
      />
      <ToastMessage
        isOpen={toast?.open}
        severity="success"
        message={toast?.message}
        handleClose={() =>
          setToast((prevState) => ({ ...prevState, open: !prevState.open }))
        }
      />
    </Grid>
  );
};
